module.exports = __webpack_public_path__ + "img/BitGoLogo.5e168702.png";